const getAppRedirectUri = (): string => {
    const configuredRedirectUri = import.meta.env.VITE_REDIRECT_URI?.trim()

    if (configuredRedirectUri) {
        return configuredRedirectUri
    }

    if (globalThis.location?.origin) {
        return new URL('/', globalThis.location.origin).toString()
    }

    return 'http://localhost:3000/'
}

const appRedirectUri = getAppRedirectUri()
const popupRedirectUri = new URL('/redirect.html', appRedirectUri).toString()

export const msalConfig = {
    auth: {
        clientId: import.meta.env.VITE_CLIENT_ID,
        authority: `https://${import.meta.env.VITE_TENANT_NAME}.b2clogin.com/${import.meta.env.VITE_TENANT_NAME}.onmicrosoft.com/${import.meta.env.VITE_SIGN_IN_POLICY_NAME}`,
        knownAuthorities: [`${import.meta.env.VITE_TENANT_NAME}.b2clogin.com`],
        redirectUri: popupRedirectUri,
        postLogoutRedirectUri: popupRedirectUri,
    },
    cache: {
        cacheLocation: 'localStorage' as const,
        storeAuthStateInCookie: true,
    },
}

export const loginRequest = {
    scopes: ['openid', 'profile', `https://${import.meta.env.VITE_TENANT_NAME}.onmicrosoft.com/${import.meta.env.VITE_API_CLIENT_ID}/access_as_user`],
}

export const b2cPolicies = {
    names: {
        signInSignUp: import.meta.env.VITE_SIGN_IN_POLICY_NAME,
        editProfile: import.meta.env.VITE_EDIT_PROFILE_POLICY_NAME,
    },
    authorities: {
        signInSignUp: {
            authority: `https://${import.meta.env.VITE_TENANT_NAME}.b2clogin.com/${import.meta.env.VITE_TENANT_NAME}.onmicrosoft.com/${import.meta.env.VITE_SIGN_IN_POLICY_NAME}`,
        },
        editProfile: {
            authority: `https://${import.meta.env.VITE_TENANT_NAME}.b2clogin.com/${import.meta.env.VITE_TENANT_NAME}.onmicrosoft.com/${import.meta.env.VITE_EDIT_PROFILE_POLICY_NAME}`,
        },
    },
    authorityDomain: `${import.meta.env.VITE_TENANT_NAME}.b2clogin.com`,
}
